/**
 * TanStack Query Configuration
 *
 * Centralized React Query client configuration with optimized defaults
 */

import { QueryClient } from '@tanstack/react-query';

/**
 * Create and configure QueryClient instance
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 3,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});
